export const getChannelTopicId = (channelId: string) =>
  `channel_${channelId.replace("|", ".")}`

export const getStoreTopicId = (storeId: string) =>
  `store_${storeId.replace("|", ".")}`

export const getEveryoneTopicId = () => "everyone"
